// react
import React, { useEffect, useContext } from "react";
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// @material-ui/core components
import TextField from '@material-ui/core/TextField';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import FormHelperText from "@material-ui/core/FormHelperText";
import CircularProgress from '@material-ui/core/CircularProgress';

// icons
import PermIdentity from "@material-ui/icons/PermIdentity";
import Check from "@material-ui/icons/Check";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import { ValidSelect } from "beaktShared/helpers/validselect";
import Select from 'react-select';
import { MaskMoney, transformValueFormatedtoFloat, transformValueFloattoFormated, MaskOnlyNumbersStart1 } from "beaktShared/helpers/masks";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";

// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import selectmultTable from "assets/jss/BeaktShared/selectmultTable";

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(selectmultTable);

export default function PacoteForm({ addItem, item, handleView, loading }) {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();
    const classes2 = useStyles2();
    const { register, handleSubmit, setValue, errors, getValues, clearError } = useForm({ mode: "onChange" });
    const [ativoCheckbox, setAtivoCheckbox] = React.useState(true);
    const [bloqueadoVenda, setBloqueadoVenda] = React.useState(false);
    const [incluirRoyaltieCheckbox, setIncluirRoyaltieCheckbox] = React.useState(true);
    
    const intialValues = {
        id: 0,
        descricao: '',
        ativo: true,
        valor: ''
    };

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ""
    });

    useEffect(() => {
        UseGetApiSimple("Franquias/GetByEstabelecimento/" + session.estabelecimentoId).then((result) => {
            if (result.status == 200) {
                session.franquiaId = result.data.franquiaId;
                if (!item.pacoteId && session.franquiaId === 1) {
                    setNotification({
                        show: true,
                        message: "Ao adquirir Semaglutida/Tirzepatida, é obrigatória a assinatura do serviço de telemedicina para prescrição e acompanhamento."
                    });
                }
            }
        });

    }, [item])

    useEffect(() => {
        loadSelectProdutos();
        loadSelectServicos();
        LoadSelectClausulas();

        if (session.estabelecimentoId === 0) {
            setshowSelectEstabelecimento(true);
            loadSelectEstabelecimentos();
        }
    }, []);

    const [listSelectServicosSelected, setlistSelectServicosSelected] = React.useState([]);
    const [servicos, setservicos] = React.useState([]);
    const [listSelectServicos, setlistSelectServicos] = React.useState([]);
    const [loadingSelectServicos, setloadingSelectServicos] = React.useState(false);
    const getEndPointSelectServicos = () => {
        let endPointGet = "";
        if (session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
            endPointGet = "servicos/ativos/byfranquia/" + session.franquiaId;
        else //Acessando tela pelo modulo Clinica   
            endPointGet = "servicos/ativos/byestabelecimento/" + session.estabelecimentoId;
        return endPointGet;
    }
    const loadSelectServicos = () => {
        setloadingSelectServicos(true);
        const endPoint = getEndPointSelectServicos();
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                //showNotification(result.message,'danger');  
                setloadingSelectServicos(false);
                return false;
            }

            let newlist = [];

            for (var i in result.data) {
                newlist.push({
                    servicoId: result.data[i].servicoId,
                    descricao: result.data[i].descricao +
                        " (" +
                        transformValueFloattoFormated(result.data[i].valor) +
                        ")"
                });
            }

            setlistSelectServicos(newlist);
            setloadingSelectServicos(false);
            return true;
        });
    }
    const handleServicoChange = event => {
        let value = event

        let lstServicosAdd = [];
        let lstServicosSelect = [];

        value.map(item => {
            lstServicosAdd.push(item.servicoId);

            lstServicosSelect.push({
                servicoId: item.servicoId,
                descricao: item.descricao,
                qtd: listSelectServicosSelected.filter(f => f.servicoId == item.servicoId).length > 0 ? listSelectServicosSelected.filter(f => f.servicoId == item.servicoId)[0].qtd : 1,
            });
        });

        setservicos(lstServicosAdd);
        setlistSelectServicosSelected(lstServicosSelect);

    };
    const changeQtdServico = (e, servicoId) => {

        let vefifyExists = listSelectServicosSelected.filter(obj => {
            return obj.servicoId === servicoId;
        });

        if (vefifyExists.length > 0) {
            vefifyExists[0].qtd = e.target.value;
            let listatualizada = listSelectServicosSelected.map(l => (l.servicoId === vefifyExists[0].servicoId ? vefifyExists[0] : l));
            setlistSelectServicosSelected(listatualizada);
        }
    }

    const [listSelectProdutosSelected, setlistSelectProdutosSelected] = React.useState([]);
    const [produtos, setprodutos] = React.useState([]);
    const [listSelectProdutos, setlistSelectProdutos] = React.useState([]);
    const [loadingSelectProdutos, setloadingSelectProdutos] = React.useState(false);
    const getEndPointSelectProdutos = () => {
        let endPointGet = "";
        if (session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
            endPointGet = "produtos/ativos/byfranquia/" + session.franquiaId;
        else //Acessando tela pelo modulo Clinica   
            endPointGet = "produtos/ativos/byestabelecimento/" + session.estabelecimentoId;
        return endPointGet;
    }
    const loadSelectProdutos = () => {
        setloadingSelectProdutos(true);
        const endPoint = getEndPointSelectProdutos();
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                setloadingSelectProdutos(false);
                return false;
            }

            let newlist = [];

            for (var i in result.data) {
                newlist.push({
                    produtoId: result.data[i].produtoId,
                    descricao: result.data[i].descricao +
                        " (" +
                        transformValueFloattoFormated(result.data[i].valor) +
                        ")"
                });
            }

            setlistSelectProdutos(newlist);
            setloadingSelectProdutos(false);
            return true;
        });
    }
    const handleProdutoChange = event => {
        let value = event

        let lstProdutosAdd = [];
        let lstProdutosSelect = [];
        value.map(item => {
            lstProdutosAdd.push(item.produtoId);

            lstProdutosSelect.push({
                produtoId: item.produtoId,
                descricao: item.descricao,
                qtd: listSelectProdutosSelected.filter(f => f.produtoId == item.produtoId).length > 0 ? listSelectProdutosSelected.filter(f => f.produtoId == item.produtoId)[0].qtd : 1,
            });
        });
        setprodutos(lstProdutosAdd);
        setlistSelectProdutosSelected(lstProdutosSelect);
    };
    const changeQtdProduto = (e, produtoId) => {

        let vefifyExists = listSelectProdutosSelected.filter(obj => {
            return obj.produtoId === produtoId;
        });

        if (vefifyExists.length > 0) {
            vefifyExists[0].qtd = e.target.value;
            let listatualizada = listSelectProdutosSelected.map(l => (l.produtoId === vefifyExists[0].produtoId ? vefifyExists[0] : l));
            setlistSelectProdutosSelected(listatualizada);
        }
    }

    //Carrega clausulas
    const [clausulaContrato, setclausulaContrato] = React.useState("");
    const [listSelectClausula, setlistSelectClausula] = React.useState([]);
    const [loadingSelectClausula, setloadingSelectClausula] = React.useState(false);

    const LoadSelectClausulas = () => {
        setloadingSelectClausula(true);
        const endPoint = "clausulaContrato/byServicoPacote/" + session.estabelecimentoId + "/" + session.franquiaId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                //showNotification(result.message,'danger');  
                setloadingSelectClausula(false);
                return false;
            }

            let list = [{ clausulaContratoId: null, descricao: "Nenhum" }, ...result.data]

            setlistSelectClausula(list);
            setloadingSelectClausula(false);
            return true;
        });
    }

    const handleClausulaChange = event => {
        let value = event
        setclausulaContrato(value);
        setValue("clausulaContrato", value);
        if (value !== "")
            clearError("clausulaContrato");
    };

    const [showSelectEstabelecimento, setshowSelectEstabelecimento] = React.useState(false);
    const [listSelectEstabelecimentos, setlistSelectEstabelecimentos] = React.useState([]);
    const [listSelectEstabelecimentosSelected, setlistEstabelecimentosSelected] = React.useState([]);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [loadingSelectEstabelecimentos, setloadingSelectEstabelecimentos] = React.useState(false);
    const loadSelectEstabelecimentos = () => {
        setloadingSelectEstabelecimentos(true);
        const endPoint = "estabelecimentos/ativos/byfranquia/" + session.franquiaId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                //showNotification(result.message,'danger');  
                setloadingSelectEstabelecimentos(false);
                return false;
            }
            setlistSelectEstabelecimentos(result.data);
            setloadingSelectEstabelecimentos(false);
            return true;
        });
    }
    const handleEstabelecimentoChange = event => {
        let value = event
        let data = getValues()

        let lstsAdd = [];
        let lstSelect = [];
        value.map(item => {
            lstsAdd.push(item.estabelecimentoId);

            lstSelect.push({
                estabelecimentoId: item.estabelecimentoId,
                pacoteId: data.id
            });
        });
        setestabelecimentos(lstsAdd);
        setlistEstabelecimentosSelected(lstSelect);
    };
    const handleClickSelecionarTodosEstabelecimentos = () => {

        let data = getValues()
        let lstsAdd = [];
        let lstSelect = [];
        listSelectEstabelecimentos.map(item => {
            lstsAdd.push(item.estabelecimentoId);

            lstSelect.push({
                estabelecimentoId: item.estabelecimentoId,
                pacoteId: data.id
            });
        });
        setestabelecimentos(lstsAdd);
        setlistEstabelecimentosSelected(lstSelect);
    }

    const [boletimOcorrencia, setboletimOcorrencia] = React.useState(null);
    const loadBoletimOcorrencia = () => {
        UseGetApiSimple("boletimocorrencia/ultimoboletimpacote/" + item.pacoteId, 0).then(result => {
            if (result.status !== 200) {
                return false;
            }
            if (result.data != null && result.data.aprovado != true) {
                setboletimOcorrencia({
                    color: result.data.aprovado == null ? "warning" : "danger",
                    message: result.data.aprovado == null ? "Aguardando Aprovação da Matriz" : ("Pacote Bloqueado pela Matriz: " + result.data.motivoReprova),
                })
            }
        });
    }

    useEffect(() => {
        if (!item.pacoteId)
            return;
        setValue('id', item.pacoteId);
        setValue('descricao', item.descricao);
        setAtivoCheckbox(item.ativo);
        let valor = transformValueFloattoFormated(item.valor);
        setValue("valor", valor);
        loadDetail(item.pacoteId);
        setValue("clausulaContrato", item.clausulaContratoId);
        setclausulaContrato(item.clausulaContratoId);
        loadBoletimOcorrencia();
        setBloqueadoVenda(item.bloqueadoVenda);
        setIncluirRoyaltieCheckbox(item.incluirRoyaltie);
    }, [item]);

    const loadDetail = (idPacote) => {
        setloadingSelectEstabelecimentos(true);
        const endPoint = "pacotes/" + idPacote;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                //showNotification(result.message,'danger');  
                setloadingSelectEstabelecimentos(false);
                return false;
            }
            loadServicesView(result.data.pacoteServicos);
            loadProdutosView(result.data.pacoteProdutos);
            loadSelectEstabelecimentoView(result.data.estabelecimentoPacotes);
            setloadingSelectEstabelecimentos(false);
            return true;
        });
    }

    const loadServicesView = (pacoteServicos) => {
        if (pacoteServicos === null)
            return;

        setlistSelectServicosSelected(pacoteServicos);

        let lstServicosAdd = [];
        pacoteServicos.map(item => {
            lstServicosAdd.push(item.servicoId);
        });
        setservicos(lstServicosAdd);
    }

    const loadProdutosView = (pacoteProdutos) => {
        if (pacoteProdutos === null)
            return;

        setlistSelectProdutosSelected(pacoteProdutos);

        let lstProdutosAdd = [];
        pacoteProdutos.map(item => {
            lstProdutosAdd.push(item.produtoId);
        });
        setprodutos(lstProdutosAdd);
    }

    const loadSelectEstabelecimentoView = (estabelecimentoPacotes) => {
        if (estabelecimentoPacotes === null)
            return;

        setlistEstabelecimentosSelected(estabelecimentoPacotes);

        let lstAdd = [];
        estabelecimentoPacotes.map(item => {
            lstAdd.push(item.estabelecimentoId);
        });
        setestabelecimentos(lstAdd);
    }

    const onSubmit = data => {
        let valor = transformValueFormatedtoFloat(data.valor);

        addItem({
            pacoteId: parseInt(data.id),
            descricao: data.descricao,
            valor: valor,
            ativo: ativoCheckbox,
            usuarioCadastroId: session.id,
            pacoteServicos: listSelectServicosSelected,
            pacoteProdutos: listSelectProdutosSelected,
            estabelecimentoPacotes: loadEstabelecimentosPacotes(),
            clausulaContratoId: data.clausulaContrato,
            bloqueadoVenda: bloqueadoVenda,
            incluirRoyaltie: incluirRoyaltieCheckbox,
            ...loadDadosMatriz()
        });
    };

    const loadDadosMatriz = () => {

        if (session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
        {
            let temp = {
                cadastradoFranquia: true,
                franquiaId: session.franquiaId
            }
            return temp;
        }
        else {
            let temp = {
                cadastradoFranquia: false,
            }
            return temp;
        }
    }

    const loadEstabelecimentosPacotes = () => {

        if (session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
        {
            return listSelectEstabelecimentosSelected;
        }
        else {
            let data = getValues()
            var estabelecimentoPacotes = [
                {
                    pacoteId: parseInt(data.id),
                    estabelecimentoId: session.estabelecimentoId
                }
            ];
            return estabelecimentoPacotes;
        }
    }

    const handleViewForm = () => {
        handleView();
    };

    return (
        <div className="maxContent">
            <form onSubmit={handleSubmit(onSubmit)}>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        {notification.show && <SnackbarContent
                            color={notification.color}
                            message={notification.message}
                            closeNotification={() => setNotification(prev => ({ ...prev, show: false }))}
                            close
                        />}
                        <Card>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <PermIdentity />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>
                                    {t('sidebar.package_register')}- <small>{t('information_message.fill_in_your_details')}</small>
                                    <input className={classes.hidden} defaultValue={intialValues.id} name="id" ref={register} />
                                </h4>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    {boletimOcorrencia != null &&
                                        <GridItem xs={12} sm={12} md={12}>
                                            <SnackbarContent
                                                message={boletimOcorrencia == null ? "" : boletimOcorrencia.message}
                                                close
                                                color={boletimOcorrencia == null ? "success" : boletimOcorrencia.color}
                                            />
                                        </GridItem>
                                    }
                                    <GridItem xs={12} sm={6} md={8}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                disabled={(item.pacoteId !== 0 && item.cadastradoFranquia === false && session.estabelecimentoId !== 0) ? true : false}
                                                error={errors.descricao ? true : false}
                                                label={t('label.description') + " *"}
                                                variant="outlined"
                                                inputRef={register({ required: true })}
                                                name="descricao"
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ maxLength: 150 }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.descricao && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={4}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                label={t('label.value') + "*"}
                                                name="valor"
                                                inputRef={register({ required: true })}
                                                error={errors.valor ? true : false}
                                                defaultValue={intialValues.valor}
                                                InputProps={{ inputComponent: MaskMoney }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.valor && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                </GridContainer>
                                <GridContainer style={{ marginBottom: '1.563rem' }}>
                                    <GridItem xs={12} sm={12} md={4}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    tabIndex={-1}
                                                    checked={ativoCheckbox}
                                                    onClick={event => { setAtivoCheckbox(event.target.checked) }}
                                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                                    icon={<Check className={classes.uncheckedIcon} />}
                                                    classes={{
                                                        checked: classes.checked,
                                                        root: classes.checkRoot
                                                    }}
                                                    name="ativo"
                                                    inputRef={register}
                                                />
                                            }
                                            classes={{
                                                label: classes.label,
                                                root: classes.labelRoot
                                            }}
                                            label={t('information_message.system_active') + "?"}
                                        />
                                    </GridItem>
                                    {
                                        session?.habilitaControleRoyalties &&
                                        <GridItem xs={12} sm={12} md={4}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        tabIndex={-1}
                                                        checked={incluirRoyaltieCheckbox}
                                                        onClick={event => { setIncluirRoyaltieCheckbox(event.target.checked) }}
                                                        checkedIcon={<Check className={classes.checkedIcon} />}
                                                        icon={<Check className={classes.uncheckedIcon} />}
                                                        classes={{
                                                            checked: classes.checked,
                                                            root: classes.checkRoot
                                                        }}
                                                        name="incluirRoyaltie"
                                                        inputRef={register}
                                                    />
                                                }
                                                classes={{
                                                    label: classes.label,
                                                    root: classes.labelRoot
                                                }}
                                                label={t('information_message.does_the_package_control_royalts')}
                                            />
                                        </GridItem>
                                    }
                                </GridContainer>
                                <GridContainer>
                                    <GridItem xs={12} sm={6} md={6}>

                                        <FormControl fullWidth className={classes.formControl}>

                                            <label className={errors.servicos ? "select__label select__label_error" : "select__label"}>{t('dashboard.services')} </label>
                                            <Select
                                                classNamePrefix="select"
                                                styles={ValidSelect(errors.servicos ? true : false)}
                                                isSearchable={true}
                                                isLoading={loadingSelectServicos}
                                                name="servicos"
                                                placeholder={t('label.select') + " ..."}
                                                isMulti={true}
                                                options={listSelectServicos}
                                                getOptionLabel={({ descricao }) => descricao}
                                                getOptionValue={({ servicoId }) => servicoId}
                                                value={listSelectServicos.filter(({ servicoId }) => servicos.indexOf(servicoId) != -1)}
                                                onChange={(value) => handleServicoChange(value || [])}

                                                ref={() => register(
                                                    { name: "servicos" })
                                                }
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.servicos && <span> {t('label.selected_services')} </span>}
                                            </FormHelperText>
                                        </FormControl>

                                        <br />

                                        {listSelectServicosSelected.length > 0 &&
                                            <div>
                                                <h4>
                                                    {t('label.selected_services')}
                                                </h4>
                                                <div className={classes2.boxSelectedBefore}>
                                                    <table>
                                                        <thead>
                                                            <tr>
                                                                <th className={classes2.thQtd}> <b>{t('label.quantity')}</b> </th>
                                                                <th className={classes2.thDesc}> <b>{t('label.description')}</b> </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {listSelectServicosSelected.map(item => (
                                                                <tr key={item.servicoId}>
                                                                    <td>
                                                                        <TextField
                                                                            error={errors.qtd ? true : false}
                                                                            variant="outlined"
                                                                            inputRef={register({ required: true })}
                                                                            type="number"
                                                                            name="qtd"
                                                                            defaultValue={item.qtd}
                                                                            InputLabelProps={{ shrink: true }}
                                                                            inputProps={{ maxLength: 3 }}
                                                                            onInput={(e) => MaskOnlyNumbersStart1(e)}
                                                                            onChange={(e) => changeQtdServico(e, item.servicoId)}
                                                                        />
                                                                        <FormHelperText className={classes.labelRootError}>
                                                                            {errors.qtd && <span> {t('label.required')} </span>}
                                                                        </FormHelperText>   </td>
                                                                    <td>
                                                                        <div className={classes2.detailDesc}>
                                                                            {item.descricao}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        }
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={6}>

                                        <FormControl fullWidth className={classes.formControl}>

                                            <label className={errors.produtos ? "select__label select__label_error" : "select__label"}>{t('dashboard.products')} </label>
                                            <Select
                                                classNamePrefix="select"
                                                styles={ValidSelect(errors.produtos ? true : false)}
                                                isSearchable={true}
                                                isLoading={loadingSelectProdutos}
                                                name="produtos"
                                                placeholder={t('label.select') + " ..."}
                                                isMulti={true}
                                                options={listSelectProdutos}
                                                getOptionLabel={({ descricao }) => descricao}
                                                getOptionValue={({ produtoId }) => produtoId}
                                                value={listSelectProdutos.filter(({ produtoId }) => produtos.indexOf(produtoId) != -1)}
                                                onChange={(value) => handleProdutoChange(value || [])}
                                                ref={() => register(
                                                    { name: "produtos" })
                                                }
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.produtos && <span> {t('label.select_a_product')} </span>}
                                            </FormHelperText>
                                        </FormControl>

                                        <br />
                                        {listSelectProdutosSelected.length > 0 &&
                                            <div>
                                                <h4>
                                                    {t('label.selected_products')}
                                                </h4>
                                                <div className={classes2.boxSelectedBefore}>
                                                    <table>
                                                        <thead>
                                                            <tr>
                                                                <th className={classes2.thQtd}> <b>{t('label.quantity')}</b> </th>
                                                                <th className={classes2.thDesc}> <b>{t('label.description')}</b> </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {listSelectProdutosSelected.map(item => (
                                                                <tr key={item.produtoId}>
                                                                    <td>
                                                                        <TextField
                                                                            error={errors.qtdprod ? true : false}
                                                                            variant="outlined"
                                                                            inputRef={register({ required: true })}
                                                                            type="number"
                                                                            name="qtdprod"
                                                                            defaultValue={item.qtd}
                                                                            InputLabelProps={{ shrink: true }}
                                                                            inputProps={{ maxLength: 3 }}
                                                                            onInput={(e) => MaskOnlyNumbersStart1(e)}
                                                                            onChange={(e) => changeQtdProduto(e, item.produtoId)}
                                                                        />
                                                                        <FormHelperText className={classes.labelRootError}>
                                                                            {errors.qtdprod && <span> {t('label.required')}</span>}
                                                                        </FormHelperText>   </td>
                                                                    <td>
                                                                        <div className={classes2.detailDesc}>
                                                                            {item.descricao}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        }
                                    </GridItem>
                                </GridContainer>
                                <GridContainer>
                                    <label style={{ paddingLeft: '1.25rem', paddingTop: '1.25rem' }}>
                                        {'* Campo não brigatório. Selecionar somente se o serviço tiver uma clausula específica!'} 
                                    </label>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <br></br>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <label className={errors.clausulaContrato ? "select__label select__label_error" : "select__label"}>{t('label.contract_clause')} </label>
                                            <Select
                                                classNamePrefix="select"
                                                styles={ValidSelect(errors.clausulaContrato ? true : false)}
                                                isSearchable={true}
                                                isLoading={loadingSelectClausula}
                                                name="clausulaContrato"
                                                placeholder={t('label.select') + " ..."}
                                                options={listSelectClausula}
                                                value={listSelectClausula.filter(({ clausulaContratoId }) => clausulaContratoId === clausulaContrato)}
                                                getOptionLabel={({ descricao }) => descricao}
                                                getOptionValue={({ clausulaContratoId }) => clausulaContratoId}
                                                onChange={(value) => handleClausulaChange(value.clausulaContratoId !== null ? value.clausulaContratoId : "")}
                                                ref={() => register(
                                                    { name: "clausulaContrato" })
                                                }
                                            />
                                        </FormControl>
                                    </GridItem>
                                </GridContainer>
                                <GridContainer>
                                    {showSelectEstabelecimento &&
                                        <GridItem xs={12} sm={12} md={12}>
                                            <br />
                                            <div style={{ border: '1px dashed #ccc', padding: '20px' }}>

                                                <GridContainer>
                                                    <GridItem xs={12} sm={6} md={6}>
                                                        <h3>{t('label.access_establishments')}</h3>
                                                    </GridItem>
                                                    <GridItem xs={12} sm={6} md={6} style={{ textAlign: 'right' }}>
                                                        <Button color="primary" round onClick={() => handleClickSelecionarTodosEstabelecimentos()}   >
                                                            {t('label.select_all_establishments')}
                                                        </Button>
                                                    </GridItem>
                                                </GridContainer>
                                                <br />
                                                <FormControl fullWidth className={classes.formControl}>

                                                    <label className={errors.estabelecimentos ? "select__label select__label_error" : "select__label"}>{t('label.establishments')} </label>
                                                    {loadingSelectEstabelecimentos && <div className="loadingitemVenda">
                                                        <CircularProgress size={20} />
                                                    </div>}
                                                    {!loadingSelectEstabelecimentos &&
                                                        <Select
                                                            styles={ValidSelect(errors.estabelecimentos ? true : false)}
                                                            classNamePrefix="select"
                                                            isSearchable={true}
                                                            placeholder={t('label.select') + " ..."}
                                                            isMulti={true}
                                                            name="estabelecimentos"
                                                            isLoading={loadingSelectEstabelecimentos}
                                                            options={listSelectEstabelecimentos}
                                                            getOptionLabel={({ descricao }) => descricao}
                                                            getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                                            value={listSelectEstabelecimentos.filter(({ estabelecimentoId }) => estabelecimentos.indexOf(estabelecimentoId) != -1)}
                                                            onChange={(value) => handleEstabelecimentoChange(value || [])}
                                                            ref={() => register({ name: "estabelecimentos" })}
                                                        />
                                                    }
                                                    <FormHelperText className={classes.labelRootError}>
                                                        {errors.estabelecimentos && <span>{t('label.select_an_establishment')}</span>}
                                                    </FormHelperText>
                                                </FormControl>
                                            </div>

                                        </GridItem>
                                    }
                                </GridContainer>
                                <Clearfix />
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                        <br />
                        <div className={classes.textCenter}>
                            <Button onClick={() => handleViewForm()} color="transparent" className={classes.updateProfileButton}>
                                {t('button.cancel')}
                            </Button>
                            <Button type="submit" color="primary" className={classes.updateProfileButton}>
                                {t('button.to_save')}
                                {loading && <div>{t('label.loading') + "..."}</div>}
                            </Button>
                        </div>
                    </GridItem>
                </GridContainer>
            </form>
        </div>
    );
}